<template>
  <div id="events-preview">
    <!-- Premium Header Card -->
    <v-card elevation="20" class="preview-card">
      <!-- Premium Header -->
      <div class="header-premium">
        <v-container class="pa-0">
          <v-row class="align-center" no-gutters>
            <v-col cols="auto" class="d-flex align-center pa-4">
              <div class="icon-box-header">
                <v-icon size="32" color="white" class="icon-pulse">mdi-file-eye</v-icon>
              </div>
              <div class="ml-4">
                <h2 class="title-header mb-1">{{ pageTitle }}</h2>
                <p class="subtitle-header mb-0">{{ pageDescription }}</p>
              </div>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" class="d-flex align-center pa-4">
              <v-btn icon @click="closePrompt" class="close-btn-header" title="Close dialog">
                <v-icon>mdi-close-circle</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <v-sheet
        id="scrolling-techniques-7"
        class="overflow-y-auto content-sheet"
        max-height="700"
      >
        <v-container class="form-container pa-6">
        <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
          <v-progress-circular indeterminate color="#3a67b1" size="50"></v-progress-circular>
        </div>

        <v-dialog eager v-model="FilePreviewFlag" v-if="FilePreviewFlag">
          <pdf-document-file-preview
            PageTitle="File Preview"
            :PreviewButtonFlag="FilePreviewFlag"
            :Documentpath="row.ConsolidateFilePath"
            @hideDialog="hideFilePreviewFlag"
            v-if="FilePreviewFlag"
          ></pdf-document-file-preview>
        </v-dialog>

        <v-container v-if="ResultFlag" class="py-0">
          <!-- Event Details Section -->
          <v-row class="mb-6">
            <v-col cols="12">
              <div class="section-header">
                <v-icon size="24" color="#3a67b1" class="mr-2">mdi-information-outline</v-icon>
                <h3 class="section-title">Event Information</h3>
              </div>
            </v-col>
          </v-row>

          <v-row wrap class="mb-6">
            <v-col cols="12" sm="6" lg="3" md="3">
              <v-card class="info-card" elevation="0">
                <v-card-text>
                  <div class="info-icon-wrapper">
                    <v-icon size="32" color="#0097d7">mdi-calendar-check</v-icon>
                  </div>
                  <h5 class="info-label">Submitted Date</h5>
                  <p class="info-value">{{ row.UpdatedAtTxt }}</p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <v-card class="info-card" elevation="0">
                <v-card-text>
                  <div class="info-icon-wrapper">
                    <v-icon size="32" color="#56bda3">mdi-briefcase</v-icon>
                  </div>
                  <h5 class="info-label">Portfolio</h5>
                  <p class="info-value">{{ row.PortfolioName }}</p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <v-card class="info-card" elevation="0">
                <v-card-text>
                  <div class="info-icon-wrapper">
                    <v-icon size="32" color="#edbe38">mdi-tag-multiple</v-icon>
                  </div>
                  <h5 class="info-label">Category</h5>
                  <p class="info-value">{{ row.EventTypeName }}</p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <v-card class="info-card" elevation="0">
                <v-card-text>
                  <div class="info-icon-wrapper">
                    <v-icon size="32" color="#e74c3c">mdi-tag</v-icon>
                  </div>
                  <h5 class="info-label">Sub Category</h5>
                  <p class="info-value">{{ row.EventSubTypeName }}</p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row wrap class="mb-6">
            <v-col cols="12" sm="6" lg="3" md="3">
              <v-card class="info-card" elevation="0">
                <v-card-text>
                  <div class="info-icon-wrapper">
                    <v-icon size="32" color="#3a67b1">mdi-home-group</v-icon>
                  </div>
                  <h5 class="info-label">Host Details</h5>
                  <p class="info-value" v-if="row.IsNhqHost">Jci NHQ</p>
                  <p class="info-value" v-else>{{ row.HostZoneName }} - {{ row.HostLomName }}</p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <v-card class="info-card" elevation="0">
                <v-card-text>
                  <div class="info-icon-wrapper">
                    <v-icon size="32" color="#0097d7">mdi-calendar-range</v-icon>
                  </div>
                  <h5 class="info-label">Event Date</h5>
                  <p class="info-value">
                    {{ row.DateFromTxt }} <span v-if="row.DateToTxt != 1">- {{ row.DateToTxt }}</span>
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <v-card class="info-card" elevation="0">
                <v-card-text>
                  <div class="info-icon-wrapper">
                    <v-icon size="32" color="#56bda3">mdi-domain</v-icon>
                  </div>
                  <h5 class="info-label">Event Type</h5>
                  <p class="info-value">{{ row.OrganizationTypeName }}</p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <v-card class="info-card" elevation="0">
                <v-card-text>
                  <div class="info-icon-wrapper">
                    <v-icon size="32" color="#edbe38">mdi-map-marker</v-icon>
                  </div>
                  <h5 class="info-label">LOM</h5>
                  <p class="info-value">{{ row.ZoneName }} - {{ row.LomName }}</p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row wrap class="mb-6">
            <v-col cols="12" sm="6" lg="3" md="3">
              <v-card class="info-card" elevation="0">
                <v-card-text>
                  <div class="info-icon-wrapper">
                    <v-icon size="32" color="#3a67b1">mdi-star-circle</v-icon>
                  </div>
                  <h5 class="info-label">100% Efficiency</h5>
                  <p class="info-value">{{ row.SubCriteriaTxt }}</p>
                  <p class="info-value small">{{ row.PointsTypeName }} - {{ row.PointsValue }} pts</p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <v-card class="info-card" elevation="0">
                <v-card-text>
                  <div class="info-icon-wrapper">
                    <v-icon size="32" color="#0097d7">mdi-text-box</v-icon>
                  </div>
                  <h5 class="info-label">Event Name</h5>
                  <p class="info-value">{{ row.JciEventName }}</p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" lg="6" md="6">
              <v-card class="info-card" elevation="0">
                <v-card-text>
                  <div class="info-icon-wrapper">
                    <v-icon size="32" color="#56bda3">mdi-map-search</v-icon>
                  </div>
                  <h5 class="info-label">Venue</h5>
                  <p class="info-value">{{ row.VenueDetails }}</p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <hr class="section-divider" />

          <!-- Description Section -->
          <v-row class="mb-6">
            <v-col cols="12">
              <div class="section-header">
                <v-icon size="24" color="#3a67b1" class="mr-2">mdi-format-text</v-icon>
                <h3 class="section-title">Description</h3>
              </div>
            </v-col>
            <v-col cols="12">
              <v-card class="description-card" elevation="0">
                <v-card-text>
                  <p class="description-text">{{ row.JciEventDescription }}</p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- Images Section -->
          <v-row wrap class="mb-6">
            <v-col cols="12" sm="6" lg="4" md="4">
              <v-card class="image-section-card" elevation="0">
                <v-card-title class="section-header">
                  <v-icon size="20" color="#3a67b1" class="mr-2">mdi-image-multiple</v-icon>
                  <span class="section-title">Invitation</span>
                </v-card-title>
                <v-card-text>
                  <viewer rebuild :images="row.InvitationImages">
                    <img
                      class="preview-image"
                      :src="src"
                      :key="src"
                      v-for="src in row.InvitationImages"
                      alt="Invitation"
                    />
                  </viewer>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" lg="4" md="4">
              <v-card class="image-section-card" elevation="0">
                <v-card-title class="section-header">
                  <v-icon size="20" color="#3a67b1" class="mr-2">mdi-image-multiple</v-icon>
                  <span class="section-title">Group Photo</span>
                </v-card-title>
                <v-card-text>
                  <viewer rebuild :images="row.WebsiteImages">
                    <img
                      class="preview-image"
                      :src="src"
                      :key="src"
                      v-for="src in row.WebsiteImages"
                      alt="Group Photo"
                    />
                  </viewer>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" lg="4" md="4">
              <v-card class="image-section-card" elevation="0">
                <v-card-title class="section-header">
                  <v-icon size="20" color="#3a67b1" class="mr-2">mdi-image-multiple</v-icon>
                  <span class="section-title">Event Photos</span>
                </v-card-title>
                <v-card-text>
                  <viewer rebuild :images="row.EventImages">
                    <img
                      class="preview-image"
                      :src="src"
                      :key="src"
                      v-for="src in row.EventImages"
                      alt="Event Photo"
                    />
                  </viewer>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <hr class="section-divider" />

          <!-- Members Section -->
          <v-row wrap class="mb-6">
            <v-col cols="12" sm="6" lg="6" md="6">
              <v-card class="member-section-card" elevation="0">
                <v-card-title class="section-header">
                  <v-icon size="24" color="#3a67b1" class="mr-2">mdi-user-star</v-icon>
                  <span class="section-title">Event Chairman</span>
                </v-card-title>
                <v-card-text class="text-center">
                  <div v-if="row.ChairmanFlag">
                    <v-card class="member-card" elevation="2">
                      <v-card-text class="text-center">
                        <v-avatar size="100" class="mb-3">
                          <img
                            :src="ChairmanData.ChairmanMemberPublicPath"
                            :alt="ChairmanData.ChairmanMemberFullname"
                            v-if="ChairmanData.ChairmanMemberPublicPath != ''"
                          />
                          <span v-else>
                            <v-icon size="50">mdi-account</v-icon>
                          </span>
                        </v-avatar>
                        <h3 class="member-name">{{ ChairmanData.ChairmanMemberFullname }}</h3>
                        <p class="member-details">{{ ChairmanData.ChairmanMemberDetails }}</p>
                      </v-card-text>
                    </v-card>
                  </div>
                  <div v-else class="empty-member">
                    <v-icon size="48" color="#ccc" class="mb-2">mdi-account-off</v-icon>
                    <p>Not Available</p>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" lg="6" md="6">
              <v-card class="member-section-card" elevation="0">
                <v-card-title class="section-header">
                  <v-icon size="24" color="#3a67b1" class="mr-2">mdi-briefcase-account</v-icon>
                  <span class="section-title">Event Director</span>
                </v-card-title>
                <v-card-text class="text-center">
                  <div v-if="row.DirectorFlag">
                    <v-card class="member-card" elevation="2">
                      <v-card-text class="text-center">
                        <v-avatar size="100" class="mb-3">
                          <img
                            :src="DirectorData.DirectorMemberPublicPath"
                            :alt="DirectorData.DirectorMemberFullname"
                            v-if="DirectorData.DirectorMemberPublicPath != ''"
                          />
                          <span v-else>
                            <v-icon size="50">mdi-account</v-icon>
                          </span>
                        </v-avatar>
                        <h3 class="member-name">{{ DirectorData.DirectorMemberFullname }}</h3>
                        <p class="member-details">{{ DirectorData.DirectorMemberDetails }}</p>
                      </v-card-text>
                    </v-card>
                  </div>
                  <div v-else class="empty-member">
                    <v-icon size="48" color="#ccc" class="mb-2">mdi-account-off</v-icon>
                    <p>Not Available</p>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- Dignitaries Section -->
          <v-row wrap class="mb-6">
            <v-col cols="12">
              <div class="section-header">
                <v-icon size="24" color="#3a67b1" class="mr-2">mdi-people</v-icon>
                <h3 class="section-title">Dignitaries</h3>
              </div>
            </v-col>
          </v-row>
          <v-row wrap class="mb-6">
            <v-col
              v-for="faculty in FacultiesData"
              :key="faculty.EventFacultyId"
              cols="12"
              sm="6"
              md="4"
              lg="3"
            >
              <v-card class="faculty-card" elevation="2">
                <v-card-text class="text-center">
                  <v-avatar size="100" class="mb-3">
                    <img :src="faculty.FacultyMemberPublicPath" :alt="faculty.FacultyMemberName" />
                  </v-avatar>
                  <h4 class="faculty-name">{{ faculty.FacultyMemberName }}</h4>
                  <p class="faculty-type">{{ faculty.FacultyTypeName }}</p>
                  <p class="faculty-details">{{ faculty.FacultyMemberDetails }}</p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <hr class="section-divider" />

          <!-- Action Buttons -->
          <v-row wrap class="mt-6">
            <v-col align="center" cols="12" md="12">
              <v-btn
                v-if="row.ConsolidateFilePath != ''"
                @click="FilePreviewFlag = true"
                class="action-button"
                large
                elevation="8"
              >
                <v-icon left size="24">mdi-file-pdf</v-icon>
                View Uploaded File
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        </v-container>
      </v-sheet>

      <v-card-actions class="pa-6">
        <v-spacer></v-spacer>
        <v-btn color="#3a67b1" @click="closePrompt" large elevated class="close-button">
          <v-icon left>mdi-close</v-icon>
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [common],
  components: {},
  props: {
    previewRecordPrompt: {
      type: Boolean,
      required: true,
    },
    recordData: {
      required: true,
    },
    pageTitle: {
      type: String,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      tableColumns1: [],
      tableOptions1: {},
      tableData1: [],

      row: {},
      ResultFlag: false,

      PreviewButtonFlag: false,
      Documentpath: "",

      LoadingFlag: false,

      TableFlag1: false,

      selected: [],
      SearchFlag: false,
      search: "",

      ChairmanData: {},
      DirectorData: {},
      DocumentsData: [],
      FacultiesData: [],

      defaultItem: {
        name: "",
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },

      FilePreviewFlag: false,
    };
  },
  computed: {},
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hidePreviewRecordPrompt");
    },
    validate() {
      console.log("validate is called");
      var result = this.$refs.form.validate();
      console.log("result=" + result);
      if (result) {
        this.addRecordDetails();
      } else {
        console.log("some errors occured");
      }
    },
    hideFilePreviewFlag() {
      console.log("hideFilePreviewFlag called");
      this.FilePreviewFlag = false;
    },
    hidePreviewRecordPrompt() {
      console.log("hidePreviewRecordPrompt called");
      this.previewRecordPrompt = false;
    },
    previewData(tr) {
      console.log("previewData called");
      // var tr = this.selected
      // var n1 = tr.length
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.Documentpath = tr.DocumentAssetPath;
        this.previewRecordPrompt = true;
      } else {
        var message = "Kindly select one record to preview";
        this.toast("error", message);
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
      var recordData = this.recordData;
      console.log("recordData=" + JSON.stringify(recordData));
      this.getTableRecords();
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var JciEventId = this.recordData.JciEventId;
      console.log("JciEventId=" + JciEventId);

      if (JciEventId != "") {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/jci-events/show";
        var upload = {
          UserInterface: 1,
          EventCode: JciEventId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.row = {};
        this.ChaimanData = {};
        this.DirectorData = {};
        this.DocumentsData = [];
        this.FacultiesData = [];
        this.ResultFlag = false;

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.LoadingFlag = true;
        this.Documentpath = "";

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            var options = response.data.options;
            var TableHeader = options.TableHeader;
            var TableOptions = options.TableOptions;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            thisIns.ResultFlag = flag;
            thisIns.tableColumns1 = TableHeader;
            thisIns.tableOptions1 = TableOptions;

            if (flag == 1) {
              thisIns.row = records;
              thisIns.ChairmanData = records.ChairmanData;
              thisIns.DirectorData = records.DirectorData;
              thisIns.DocumentsData = records.Documents;
              thisIns.FacultiesData = records.Faculties;
              // thisIns.toast("success", output);
            } else {
              // thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "Your session is expired. Kindly login again. ";
        console.log("error=" + message);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss" scoped>
// JCI Approved Color Palette
$jci-navy: #3a67b1;
$jci-aqua: #0097d7;
$jci-gold: #edbe38;
$jci-seaform: #56bda3;
$jci-text-90: #414042;
$jci-off-black: #0a0f29;
$jci-white: #ffffff;

// Alias for compatibility
$navy: $jci-navy;
$aqua: $jci-aqua;
$gold: $jci-gold;
$seaform: $jci-seaform;
$text-white: $jci-white;
$transition-base: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

// Animation Keyframes
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
}

// Pulse animation for icon
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}

// Main Card
.preview-card {
  border-radius: 18px !important;
  overflow: hidden !important;
  box-shadow: 0 12px 40px rgba(58, 103, 177, 0.2) !important;

  &:hover {
    box-shadow: 0 16px 48px rgba(58, 103, 177, 0.25) !important;
  }
}

// ============================================
// HEADER STYLES
// ============================================
.header-premium {
  background: linear-gradient(135deg, $aqua 0%, $navy 100%);
  position: relative;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(58, 103, 177, 0.3);

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 50%, rgba(237, 190, 56, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 80% 80%, rgba(86, 189, 163, 0.1) 0%, transparent 50%);
    pointer-events: none;
  }
}

.icon-box-header {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(15px);
  border-radius: 16px;
  padding: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.3);
  animation: float 4s ease-in-out infinite;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 56px;
  min-height: 56px;
}

.icon-pulse {
  animation: pulse 2s ease-in-out infinite;
}

.title-header {
  font-size: 24px;
  font-weight: 900;
  color: $text-white;
  letter-spacing: 0.6px;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
  margin: 0;
}

.subtitle-header {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.close-btn-header {
  background: rgba(255, 255, 255, 0.15) !important;
  border: 2px solid rgba(255, 255, 255, 0.3) !important;
  color: white !important;
  border-radius: 12px;
  transition: $transition-base;

  &:hover {
    background: rgba(255, 255, 255, 0.25) !important;
    transform: scale(1.1);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  }
}

// ============================================
// CONTENT SHEET
// ============================================
.content-sheet {
  background: linear-gradient(135deg, #f5f7fa 0%, #e8f0f7 100%);
}

.form-container {
  background: transparent;
}

// ============================================
// SECTION HEADERS
// ============================================
.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid $gold;
  animation: slideInLeft 0.5s ease-out;

  .v-icon {
    flex-shrink: 0;
  }

  .section-title {
    font-size: 18px;
    font-weight: 600;
    color: $navy;
    margin: 0;
    letter-spacing: -0.3px;

    @media (max-width: 600px) {
      font-size: 16px;
    }
  }
}

// ============================================
// INFO CARDS
// ============================================
.info-card {
  background: linear-gradient(135deg, rgba($navy, 0.05) 0%, rgba($aqua, 0.05) 100%);
  border: 1px solid rgba($aqua, 0.15);
  border-radius: 14px;
  padding: 18px;
  transition: $transition-base;
  animation: fadeInScale 0.4s ease-out;

  &:hover {
    background: linear-gradient(135deg, rgba($navy, 0.08) 0%, rgba($aqua, 0.08) 100%);
    border-color: $aqua;
    box-shadow: 0 8px 24px rgba($aqua, 0.1);
    transform: translateY(-4px);
  }

  .info-icon-wrapper {
    margin-bottom: 12px;
  }

  .info-label {
    font-size: 12px;
    font-weight: 600;
    color: $navy;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: 8px;
    margin: 0 0 8px 0;
  }

  .info-value {
    font-size: 16px;
    color: $jci-text-90;
    font-weight: 500;
    word-break: break-word;
    margin: 0;

    @media (max-width: 600px) {
      font-size: 14px;
    }

    &.small {
      font-size: 13px;
    }
  }
}

// ============================================
// DESCRIPTION CARD
// ============================================
.description-card {
  background: linear-gradient(135deg, rgba($seaform, 0.05) 0%, rgba($aqua, 0.05) 100%);
  border: 1px solid rgba($seaform, 0.2);
  border-left: 4px solid $seaform;
  border-radius: 12px;
  transition: $transition-base;
  animation: fadeInScale 0.4s ease-out;

  &:hover {
    box-shadow: 0 8px 24px rgba($seaform, 0.1);
  }
}

.description-text {
  font-size: 15px;
  color: $jci-text-90;
  line-height: 1.8;
  word-break: break-word;
  margin: 0;
}

// ============================================
// IMAGE SECTION CARDS
// ============================================
.image-section-card {
  background: linear-gradient(135deg, $jci-white 0%, rgba($aqua, 0.02) 100%);
  border: 1px solid rgba($aqua, 0.2);
  border-radius: 14px;
  transition: $transition-base;
  animation: fadeInScale 0.4s ease-out;

  &:hover {
    border-color: $aqua;
    box-shadow: 0 12px 36px rgba($aqua, 0.15);
    transform: translateY(-4px);
  }

  .v-card__title {
    padding: 18px !important;
  }

  img {
    border-radius: 10px;
    border: 2px solid $gold;
    max-width: 200px;
    height: auto;
    margin: 8px;
    transition: $transition-base;
    cursor: pointer;

    &:hover {
      transform: scale(1.05);
      box-shadow: 0 8px 20px rgba($aqua, 0.2);
    }
  }
}

// ============================================
// MEMBER SECTION CARDS
// ============================================
.member-section-card {
  background: linear-gradient(135deg, $jci-white 0%, rgba($navy, 0.02) 100%);
  border: 1px solid rgba($navy, 0.2);
  border-radius: 14px;
  transition: $transition-base;
  animation: fadeInScale 0.4s ease-out;

  &:hover {
    border-color: $navy;
    box-shadow: 0 12px 36px rgba($navy, 0.15);
    transform: translateY(-4px);
  }

  .v-card__title {
    padding: 18px !important;
    border-bottom: 2px solid rgba($gold, 0.3);
  }

  .v-card__text {
    padding: 24px !important;
  }

  .v-avatar {
    border: 3px solid $gold;
    animation: fadeInScale 0.5s ease-out;

    img {
      transition: $transition-base;
    }

    &:hover img {
      transform: scale(1.1);
    }
  }

  .member-name {
    font-size: 16px;
    font-weight: 600;
    color: $navy;
    margin: 12px 0 4px 0;
    letter-spacing: -0.3px;

    @media (max-width: 600px) {
      font-size: 14px;
    }
  }

  .member-role {
    font-size: 13px;
    font-weight: 500;
    color: $aqua;
    margin: 4px 0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .member-details {
    font-size: 12px;
    color: $jci-text-90;
    margin: 4px 0 0 0;
    line-height: 1.4;
  }

  .no-data-box {
    text-align: center;
    padding: 30px 20px;
    background: rgba($navy, 0.03);
    border-radius: 10px;
    border: 2px dashed rgba($navy, 0.2);

    .v-icon {
      color: #ccc;
    }

    p {
      color: #999;
      margin-top: 8px;
      font-size: 13px;
    }
  }
}

// ============================================
// FACULTY CARDS
// ============================================
.faculty-card {
  background: linear-gradient(135deg, $jci-white 0%, rgba($aqua, 0.02) 100%);
  border: 1px solid rgba($aqua, 0.2);
  border-radius: 14px;
  transition: $transition-base;
  animation: fadeInScale 0.4s ease-out;

  &:hover {
    border-color: $aqua;
    box-shadow: 0 12px 36px rgba($aqua, 0.15);
    transform: translateY(-6px);
  }

  .v-card__text {
    padding: 20px !important;
  }

  .v-avatar {
    border: 3px solid $gold;
    animation: fadeInScale 0.5s ease-out;

    img {
      transition: $transition-base;
    }

    &:hover img {
      transform: scale(1.1);
    }
  }

  .faculty-name {
    font-size: 16px;
    font-weight: 600;
    color: $navy;
    margin: 12px 0 4px 0;
    letter-spacing: -0.3px;

    @media (max-width: 600px) {
      font-size: 14px;
    }
  }

  .faculty-type {
    font-size: 13px;
    font-weight: 500;
    color: $aqua;
    margin: 4px 0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .faculty-details {
    font-size: 12px;
    color: $jci-text-90;
    margin: 4px 0 0 0;
    line-height: 1.4;
  }
}

// ============================================
// ACTION BUTTONS
// ============================================
.action-button {
  background: linear-gradient(135deg, $navy 0%, $aqua 100%) !important;
  color: $jci-white !important;
  border-radius: 12px !important;
  font-weight: 600;
  padding: 12px 24px !important;
  transition: $transition-base;
  box-shadow: 0 8px 24px rgba($navy, 0.2) !important;

  &:hover {
    box-shadow: 0 12px 36px rgba($navy, 0.3) !important;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  .v-icon {
    margin-right: 8px;
  }
}

// ============================================
// CLOSE BUTTON
// ============================================
.close-button {
  background: linear-gradient(135deg, $gold 0%, rgba($gold, 0.8) 100%) !important;
  color: $jci-off-black !important;
  font-weight: 600;
  transition: $transition-base;

  &:hover {
    box-shadow: 0 12px 36px rgba($gold, 0.3) !important;
    transform: translateY(-2px);
  }
}

// ============================================
// SECTION DIVIDER
// ============================================
.section-divider {
  border: none;
  height: 1px;
  background: linear-gradient(90deg, transparent, $aqua, transparent);
  margin: 32px 0;

  @media (max-width: 600px) {
    margin: 20px 0;
  }
}

// ============================================
// CARD ACTIONS
// ============================================
.v-card__actions {
  background: linear-gradient(135deg, rgba($navy, 0.03) 0%, rgba($aqua, 0.03) 100%);
  border-top: 1px solid rgba($aqua, 0.15);
}

// ============================================
// EVENTS PREVIEW CONTAINER
// ============================================
#events-preview {
  .v-card {
    border-radius: 16px !important;
    transition: $transition-base;

    &:hover {
      box-shadow: 0 12px 48px rgba($navy, 0.12) !important;
    }
  }

  .preview-content {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.6;
    color: $jci-text-90;
    margin: 0;

    @media (max-width: 600px) {
      font-size: 13px;
    }
  }
}

// ============================================
// RESPONSIVE DESIGN
// ============================================
@media (max-width: 1200px) {
  .title-header {
    font-size: 22px;
  }
}

@media (max-width: 960px) {
  .title-header {
    font-size: 20px;
  }

  .subtitle-header {
    font-size: 12px;
  }

  .icon-box-header {
    min-width: 50px;
    min-height: 50px;
    padding: 10px;

    .v-icon {
      font-size: 28px !important;
    }
  }
}

@media (max-width: 768px) {
  .section-header {
    .section-title {
      font-size: 16px;
    }
  }

  .info-card {
    padding: 14px;
  }
}

@media (max-width: 600px) {
  .title-header {
    font-size: 18px;
  }

  .subtitle-header {
    font-size: 11px;
  }

  .icon-box-header {
    min-width: 46px;
    min-height: 46px;
    padding: 8px;

    .v-icon {
      font-size: 24px !important;
    }
  }

  .section-header {
    .section-title {
      font-size: 14px;
    }

    .v-icon {
      font-size: 18px !important;
    }
  }

  .info-card {
    padding: 12px;

    .info-value {
      font-size: 13px;
    }
  }

  .faculty-name {
    font-size: 12px;
  }

  .faculty-type {
    font-size: 11px;
  }

  .section-divider {
    margin: 16px 0;
  }
}

@media (max-width: 480px) {
  .title-header {
    font-size: 16px;
  }

  .icon-box-header {
    min-width: 42px;
    min-height: 42px;

    .v-icon {
      font-size: 20px !important;
    }
  }
}
</style>